"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableHeader = void 0;
var react_1 = __importDefault(require("react"));
var DataTableHeader = function (_a) {
    var children = _a.children, width = _a.width;
    var style = width ? { width: String(width) + "%" } : {};
    return (react_1.default.createElement("th", { className: "text-grey-darker p-4 align-middle", style: style }, children));
};
exports.DataTableHeader = DataTableHeader;
